import type { ReactNode } from "react";
import { useLingui } from "@lingui/react/macro";
import { Heading } from "@medoma/components/Heading/Heading";
import { BackButton } from "@/components/NavigationButtons/NavigationButtons";
import styles from "./CareEpisodeSubpage.module.scss";

export const CareEpisodeSubpage = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  const { t } = useLingui();

  return (
    <section className={styles.subpage}>
      <header className={styles.header}>
        <BackButton asLinkTo=".." relative="path" ariaLabel={t`Tillbaka`} />
        <Heading level="h2">{title}</Heading>
      </header>
      {children}
    </section>
  );
};
